import React, { useEffect, useState } from 'react';
import { getShows } from '../services/api';
import { Show } from '../types/api';

export const Shows: React.FC = () => {
  const [shows, setShows] = useState<Show[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchShows = async () => {
      try {
        const response = await getShows();
        setShows(response.items);
      } catch (err) {
        setError('Failed to load shows');
        console.error('Error loading shows:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchShows();
  }, []);

  if (loading) {
    return <div className="text-center py-4">Loading shows...</div>;
  }

  if (error) {
    return <div className="text-center py-4 text-red-600">{error}</div>;
  }

  return (
    <div>
      <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
        Today's Highlights
      </h3>
      <div className="grid grid-cols-2 gap-4">
        {shows.map((show) => (
          <a
            key={show.id}
            href={show.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group block"
          >
            <div className="relative" style={{ paddingBottom: '56.8%' }}>
              <img
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/shows/${show.imageFile}`}
                alt={show.nameEn}
                className="absolute inset-0 w-full h-full object-cover rounded-lg group-hover:opacity-90 transition-opacity"
              />
            </div>
            <h4 className="mt-2 text-sm font-medium text-gray-900 group-hover:text-blue-600 transition-colors">
              {show.nameEn}
            </h4>
          </a>
        ))}
      </div>
    </div>
  );
}; 